import { ColumnsFromDB } from "../interfaces/gridInterfaces";
import { isTimeSeriesPresent } from "./xTablesHelper";
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek'; // For working with ISO weeks
import isBetween from 'dayjs/plugin/isBetween';
import { getFlatChildrenColumnOfTimeSeries } from "./helpersSubModule";

dayjs.extend(isoWeek);
dayjs.extend(isBetween);

export const makeFirstColumnAlwaysVisible = (column: ColumnsFromDB, columnArray: ColumnsFromDB[]): void => {
   if (columnArray.length !== 0) {
      column.columnGroupShow = 'open'
   }
   else delete column.columnGroupShow
   columnArray.push(column)
}


export const reGroupTimeSeries = (timeSeriesColumn: ColumnsFromDB): ColumnsFromDB => {
   let previousWeekColumns: ColumnsFromDB[] = []
   let currentWeekColumns: ColumnsFromDB[] = []
   let nextWeekColumns: ColumnsFromDB[] = []
   let groupedTimeSeriesChildren: ColumnsFromDB[] = []
   let block: any = {};

   if (timeSeriesColumn?.block) {
     try {
       block = JSON.parse(timeSeriesColumn.block);
     } catch (error) {
       console.error("Error parsing block JSON:", error);
     }
   }
      if(!timeSeriesColumn) return timeSeriesColumn
   timeSeriesColumn?.children?.forEach((col) => {
      if (col.headerName === 'Total') {
         groupedTimeSeriesChildren.push(col)
      }
      else {
         let currentDate = dayjs()
         const columnDate = dayjs(col.field, 'MM-DD-YYYY');

         if(block && block.frequency === "month"){
            if (columnDate.isBefore(currentDate, 'month')) {
               if (previousWeekColumns.length === 0) col.columnGroupShow; 
               makeFirstColumnAlwaysVisible(col, previousWeekColumns);
           } else if (columnDate.isSame(currentDate, 'month')) { 
               makeFirstColumnAlwaysVisible(col, currentWeekColumns);
           } else if (columnDate.isAfter(currentDate, 'month')) {
               makeFirstColumnAlwaysVisible(col, nextWeekColumns);
           }
         }else{
            if (columnDate.isoWeekYear() < currentDate.isoWeekYear() ||
               (columnDate.isoWeekYear() === currentDate.isoWeekYear() && columnDate.isoWeek() < currentDate.isoWeek())) {
               if (previousWeekColumns.length === 0) col.columnGroupShow;
               makeFirstColumnAlwaysVisible(col, previousWeekColumns);
            } else if (columnDate.isoWeekYear() === currentDate.isoWeekYear() && columnDate.isoWeek() === currentDate.isoWeek()) {
               makeFirstColumnAlwaysVisible(col, currentWeekColumns);
            } else if (columnDate.isoWeekYear() > currentDate.isoWeekYear() ||
               (columnDate.isoWeekYear() === currentDate.isoWeekYear() && columnDate.isoWeek() > currentDate.isoWeek())) {
               makeFirstColumnAlwaysVisible(col, nextWeekColumns);
            }
        
         }
      }

   })

   const isMonthly = block && block.frequency === "month";

   if (previousWeekColumns && previousWeekColumns.length) {
      let uniqueColumnId = uuidv4()
      groupedTimeSeriesChildren.push({
         headerName: isMonthly ? "Previous Months": "Previous Weeks",
         groupId: uniqueColumnId,
         colId: uniqueColumnId,
         // columnElasticid: uniqueColumnId,  //because this column will not be saved to DB
         block: 'timeseries',
         children: previousWeekColumns,
         columnGroupShow: 'open'
      })
   }

   if (currentWeekColumns && currentWeekColumns.length) {
      let uniqueColumnId = uuidv4()
      groupedTimeSeriesChildren.push({
         headerName: isMonthly ? "Current Month": "Current Week",
         groupId: uniqueColumnId,
         colId: uniqueColumnId,
         // columnElasticid: uniqueColumnId,  //because this column will not be saved to DB
         block: 'timeseries',
         children: currentWeekColumns,
         columnGroupShow: 'open'
      })
   }

   if (nextWeekColumns && nextWeekColumns.length) {
      let uniqueColumnId = uuidv4()
      groupedTimeSeriesChildren.push({
         headerName: isMonthly ? "Next Months": "Next Weeks",
         groupId: uniqueColumnId,
         colId: uniqueColumnId,
         // columnElasticid: uniqueColumnId,  //because this column will not be saved to DB
         block: 'timeseries',
         children: nextWeekColumns,
         columnGroupShow: 'open'
      })
   }

   timeSeriesColumn.children = groupedTimeSeriesChildren

   return timeSeriesColumn
}
export const segregatePreviousAndCurrentWeekOfTimeSeries = (columns: ColumnsFromDB[]): ColumnsFromDB[] => {
   const isTimeSeriesPresentInColumns: number = isTimeSeriesPresent(columns);

   if (isTimeSeriesPresentInColumns === -1) return columns;

   let timeSeriesColumn = columns[isTimeSeriesPresentInColumns]
   timeSeriesColumn.children = getFlatChildrenColumnOfTimeSeries(timeSeriesColumn.children);

   timeSeriesColumn = reGroupTimeSeries(timeSeriesColumn)

   columns.splice(isTimeSeriesPresentInColumns, 1, timeSeriesColumn)

   const isLevelOfColumnGroupingMoreThanOne: boolean = isTimeSeriesPresentInColumns != undefined
   // if(isLevelOfColumnGroupingMoreThanOne) columns = putSingleLevelParentToBottomMostLevel(columns)


   return columns
}

export const putSingleLevelParentToBottomMostLevel = (columns: ColumnsFromDB[]) => {
   return columns.map((col, index) => {
      if (col.children) {
         const hasChildren = col.children.reduce((acc, current) => {
            // If the current object has a 'children' property, set acc to true
            return acc || current.hasOwnProperty('children');
         }, false);
         if (!hasChildren) {
            col = {
               groupId: uuidv4(),
               children: [col]
            }
         }
      }
      return col
   })
}